import _ from 'lodash';

class MenuMainController {
  /* @ngInject */

  constructor($log, $rootScope, $timeout,
              $filter, $translate, $window, MenuActions,
              MenuStore, ModalFactory, StoreStates,
              MerchantConfigurationService, MerchantVasService, ProductsStore, StorageService, CatalogService) {

    const that = this;

    that.vassesForCurrentMerchant = [];

    that.loading = {
      menus: false
    };

    this.showDetails = 0;

    this.toggleDetails = () => {
      that.showDetails = (!that.showDetails) ? 1 : 0;
    };
    that.itemsDialog = {
      id: 'items_dialog',
      title: $filter('translate')(`menu.main.modal.errortitle`),
      text: $filter('translate')(`menu.main.modal.modalbody.deactivemenu`),
      isConfirm: false,
      closeFunc: undefined,
      confirmFunc: {}
    };

    that.vasMenus = {};



    const loadDataForResume = () => {

      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasesForCurrent(merchantProfile.business.id).then(
        (ok) => {

          that.vassesForCurrentMerchant = ok.data['_embedded'];

          CatalogService.getMenus().then(
            (data) => {
              that.Menus = data;
              angular.forEach(that.vassesForCurrentMerchant.vasses,
                (vas) => {
                    that.vasMenus[vas.name] = vas.configuration.menuId;
                }
              );

              if (!that.vasMenus || that.vasMenus.length === 0) {
                that.showVasConfigurationMenuError();
              }

            }
          );

        }
      );


    };

    that.isMenuActiveForVas = (menuId, vasName)=>{
      return that.vasMenus[vasName] === menuId;
    };

    const showMenu = (menus) => {
      that.menus = _.map(menus, menu => {

        const parsedMenu = menu;
        parsedMenu.state = menu.active;
        if (parsedMenu.active === true) {
          that.activeMenu = parsedMenu;
        }

        const count = menu.products.length;

        if (count === 0) {
          parsedMenu.countLabel = $translate.instant('menu.main.count.empty');
        } else if (count === 1) {
          parsedMenu.countLabel = $translate.instant('menu.main.count.product', { count });
        } else {
          parsedMenu.countLabel = $translate.instant('menu.main.count.products', { count });
        }

        return parsedMenu;
      });
      that.loading.menus = false;
    };

    const loadMenus = () => {
      that.menus = []
      if (MenuStore.getMenuStoreState() === StoreStates.STORE_VALID) {
        showMenu(MenuStore.getMenus());
      } else if (MenuStore.getMenuStoreState() !== StoreStates.STORE_PENDING_UPDATE) {
        that.loading.menus = true;
        MenuActions.getMenus();
      } else {
        that.loading.menus = true;
      }
    };

    this.onStoreSelected = () => {
      MenuStore.forceExpired();
      ProductsStore.forceExpired();
      init();
    }

    const init = () => {
      loadMenus();
      loadDataForResume();
      /*MerchantConfigurationService.getCheckinConfiguration().then(
        (settings) => {
          that.settings = settings;
        },
        (reason) => {
          $log.error('MenuMainController', 'loadSettings', reason);
        });*/
    };

    that.$onInit = init;

    const closeModal = modal => {
      modal.deactivate();
      $timeout(modal.destroy, 1000);
    };

    that.createMenu = () => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        class: 'large',
        template: '<edit-menu mode="create" on-cancel="cancel()"></edit-menu>',
        contentScope: {
          cancel: () => closeModal(modal)
        }
      });

      modal.activate();
    };

    const deregMenuUpdateListener = $rootScope.$on('MENU_UPDATE', loadMenus);
    const deregMenuUpdateTableListener = $rootScope.$on('MENU_REFRESH', loadDataForResume);
    const deregMenuUpdateFailListener = $rootScope.$on('MENU_FAIL', () => {
      that.loading.menus = false;
    });

    that.$onDestroy = () => {
      deregMenuUpdateListener();
      deregMenuUpdateFailListener();
    };


  }
}

export default MenuMainController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/main.controller.js
 **/